export const URL = 'Invalid URL. Your URL should start with http:// or https://';
export const REQUIRED = 'Required';
export const MIN = 'must be greater than or equal to ${min}';
export const MAX = 'must be less than or equal to ${max}';
export const BE_NUMBER = 'must be a number';
